import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  Transaction_Book,
  Transaction_Club,
  Transaction_Login,
  Transaction_Payment,
  Transaction_Profile,
} from "../../Connections/Transaction";

import MyBook from "./MyBook";
import Page from "../Page/Page";
import History from "./History";
import Transfer from "./Transfer";
import Rechargewallet from "./Rechargewallet";
import Registerprofile from "./Registerprofile";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import PictureProfile from "./PictureProfile";
import { Swiper, SwiperSlide } from "swiper/react";

import "../../Styles/Profile.css";
import { Autoplay, Navigation, Pagination } from "swiper";

const Profile = () => {
  const navigator = useNavigate();

  // =============================================

  const [transferModal, setTransferModal] = useState(false);
  const [rechargewalletModal, setRechargewalletModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [myBookModal, setMyBookModal] = useState(false);

  const [user, setUser] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [profileIsComplite, setProfileIsComplite] = useState(false);

  // =============================================

  const getProfile = () => {
    Transaction_Club.GetHomeClub()
      .then((res) => {
        if (res[0]) setUserInfo(res[2].data);
      })
      .catch((err) => console.log(err));
    Transaction_Profile.GetProfile().then((res) => {
      if (res[0]) setUser(res[2].data);
    });
    Transaction_Book.GetOneBooks(1).then((res) => {
      if (res[0]) setProfileIsComplite(res[2].data.isProfileComplete);
    });
  };

  const handleLogout = () => {
    Transaction_Login.Logout().then((res) => window.location.reload());
  };

  const handleMobileTopMenuAction = () => {
    if (transferModal) {
      setTransferModal(false);
    } else if (rechargewalletModal) {
      setRechargewalletModal(false);
    } else if (historyModal) {
      setHistoryModal(false);
    } else if (myBookModal) {
      setMyBookModal(false);
    } else {
      navigator("/");
    }
  };

  // =============================================

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const Authority = urlParams.get("Authority");
    const Status = urlParams.get("Status");
    if (Authority != null && Status != "Ok") {
      Transaction_Payment.VerifyPayment(Authority).then((res) => getProfile());
    }
  }, []);

  // =============================================

  return (
    <Page>
      <MobileNavBar action={handleMobileTopMenuAction} text="پروفایل" />
      {transferModal ? (
        <Transfer
          walletBalance={user.balance}
          close={() => setTransferModal(false)}
        />
      ) : null}
      {rechargewalletModal ? (
        <Rechargewallet
          walletBalance={user.balance}
          close={() => setRechargewalletModal(false)}
        />
      ) : null}
      {historyModal ? <History close={() => setHistoryModal(false)} /> : null}
      {myBookModal ? <MyBook close={() => setMyBookModal(false)} /> : null}

      {localStorage.getItem("Token") ? (
        <div className="Profile">
          <div className="Profile-top">
            <div className="Profile-top-right">
              <div className="Profile-top-right-inside">
                <div className="Profile-top-right-inside-text">
                  <div className="Profile-top-right-inside-text-display">
                    <p
                      className="Profile-top-right-inside-text-name"
                      style={{ textAlign: "center" }}
                    >
                      {user.name || "کاربر"}
                    </p>
                    <p className="Profile-top-right-inside-text-phone number-font">
                      {user.mobile}
                    </p>
                  </div>
                </div>
                {window.outerWidth < 993 ? (
                  <div
                    style={{ marginTop: "15px", zIndex: 40 }}
                    className="Bashgah-inside-item1-res"
                  >
                    <div className="Bashgah-inside-item1-res-top">
                      <div className="Bashgah-inside-item1-res-top-box margin-box-res">
                        <div
                          className="Bashgah-inside-item1-res-box-inside"
                          onClick={() =>
                            navigator("/hisstori/club/my-coins", {
                              state: { from: "club" },
                            })
                          }
                        >
                          <img
                            className="Bashgah-inside-item1-res-box-inside-img"
                            src="/imgs/bashgah/bashgah-seke.svg"
                          />
                          <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                            {userInfo.coins} سکه
                          </p>
                        </div>
                      </div>
                      <div className="Bashgah-inside-item1-res-top-box margin-box-res">
                        <div
                          className="Bashgah-inside-item1-res-box-inside"
                          onClick={() =>
                            navigator("/hisstori/club/my-scores", {
                              state: { from: "club" },
                            })
                          }
                        >
                          <img
                            className="Bashgah-inside-item1-res-box-inside-img"
                            src="/imgs/bashgah/bashgah-group.svg"
                          />
                          <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                            {userInfo.scores} امتیاز
                          </p>
                        </div>
                      </div>
                      <div
                        className="Bashgah-inside-item1-res-top-box"
                        onClick={() =>
                          navigator("/hisstori/club/invite-friend", {
                            state: { from: "club" },
                          })
                        }
                      >
                        <div className="Bashgah-inside-item1-res-box-inside">
                          <img
                            className="Bashgah-inside-item1-res-box-inside-img"
                            src="/imgs/bashgah/bashgah-user.svg"
                          />
                          <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                            {userInfo.invites} دعوت دوست
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="Bashgah-inside-item1-res-bottom">
                      <div className="Bashgah-inside-item1-res-top-box margin-box-res">
                        <div
                          className="Bashgah-inside-item1-res-box-inside"
                          onClick={() =>
                            navigator("/hisstori/club/my-medals", {
                              state: { from: "club" },
                            })
                          }
                        >
                          <img
                            className="Bashgah-inside-item1-res-box-inside-img"
                            src="/imgs/bashgah/bashgah-medal.svg"
                          />
                          <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                            {userInfo.medals} مدال
                          </p>
                        </div>
                      </div>
                      <div
                        className="Bashgah-inside-item1-res-top-box margin-box-res"
                        // onClick={() =>
                        //   navigator("/hisstori/club/free-discussion", {
                        //     state: { from: "club" },
                        //   })
                        // }
                      >
                        <div className="Bashgah-inside-item1-res-box-inside">
                          <img
                            className="Bashgah-inside-item1-res-box-inside-img"
                            src="/imgs/bashgah/bashgah-heart.svg"
                          />
                          <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                            {userInfo.likes} لایک دریافتی
                          </p>
                        </div>
                      </div>
                      <div
                        className="Bashgah-inside-item1-res-top-box"
                        onClick={() =>
                          navigator("/hisstori/club/my-signs", {
                            state: { from: "club" },
                          })
                        }
                      >
                        <div className="Bashgah-inside-item1-res-box-inside">
                          <img
                            className="Bashgah-inside-item1-res-box-inside-img"
                            src="/imgs/bashgah/bashgah-tala.svg"
                          />
                          <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                            {userInfo.signs} نشان
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div className="Profile-top-right-inside-button">
                  <button
                    onClick={() => {
                      navigator("/edit-profile");
                    }}
                    className="Profile-top-right-inside-button-edit"
                  >
                    {profileIsComplite ? "ویرایش اطلاعات" : "تکمیل اطلاعات"}
                  </button>
                  <button
                    onClick={handleLogout}
                    className="Profile-top-right-inside-button-getout"
                  >
                    خروج از حساب
                  </button>
                </div>
              </div>
            </div>
            <div className="Profile-top-left">
              <PictureProfile profileSrc={user.avatar} iconChange={false} />
            </div>
          </div>
          {window.outerWidth > 993 ? (
            <div className="parent-score">
              {/* score item 1  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-coins", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-seke.svg" />
                <p> {userInfo.coins} سکه</p>
              </div>
              {/* score item 2  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-scores", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-group.svg" />
                <p>{userInfo.scores} امتیاز</p>
              </div>
              {/* score item 3  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/invite-friend", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-user.svg" />
                <p>{userInfo.invites} دعوت کاربر</p>
              </div>
              {/* score item 4  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-medals", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-medal.svg" />
                <p>{userInfo.medals} مدال</p>
              </div>
              {/* score item 5  */}
              <div className="score-item">
                <img src="/imgs/bashgah/bashgah-heart.svg" />
                <p>{userInfo.likes} لایک دریافتی</p>
              </div>
              {/* score item 6  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-signs", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-tala.svg" />
                <p>{userInfo.signs} نشان</p>
              </div>
            </div>
          ) : null}
          <div className="Profile-center">
            <div className="Profile-center-left">
              <div className="Profile-bottom-right-inside">
                <div className="Profile-bottom-right-inside-top">
                  <p className="Profile-bottom-right-inside-top-text">
                    اطلاعات پویش من
                  </p>
                </div>
                <div className="Poyesh desktop-hidden ">
                  {/* <Swiper
                    slidesPerView={2}
                    navigation
                    spaceBetween={10}
                    className={"Poyesh_swiper-wrapper"}
                    breakpoints={{
                      768: {
                        slidesPerView: 4,
                      },
                      700: {
                        slidesPerView: 4,
                      },
                      600: {
                        slidesPerView: 4,
                      },
                      500: {
                        slidesPerView: 3,
                      },
                      400: {
                        slidesPerView: 3,
                      },
                      300: {
                        slidesPerView: 2,
                      },
                    }}
                  >
                    <SwiperSlide>
                      <div
                        className="Profile-bottom-left-inside-center-border-button1"
                        onClick={() => setMyBookModal(true)}
                      >
                        <button className="Profile-center-left-inside-right-bottom-button button-res">
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            کتاب های من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Link
                        to={"/activities"}
                        className="Profile-bottom-left-inside-center-border-button1"
                      >
                        <button className="Profile-center-left-inside-right-bottom-button button-res">
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            فعالیت های من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </Link>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Link
                        to={"/saved"}
                        className="Profile-bottom-left-inside-center-border-button1"
                      >
                        <button className="Profile-center-left-inside-right-bottom-button button-res">
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            ذخیره های من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </Link>
                    </SwiperSlide>
                    <SwiperSlide>
                      <Link
                        to={"/offer-codes"}
                        className="Profile-bottom-left-inside-center-border-button1"
                      >
                        <button className="Profile-center-left-inside-right-bottom-button button-res">
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            کدهای تخفیف من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </Link>
                    </SwiperSlide>
                  </Swiper> */}
                </div>
                <div className="Profile-bottom-right-inside-centeer-display">
                  <div className="Profile-bottom-right-inside-center">
                    <div className="Profile-bottom-right-inside-center-display">
                      <div
                        className="Profile-bottom-right-inside-center-border-button1"
                        onClick={() => setMyBookModal(true)}
                      >
                        <button className="Profile-center-left-inside-right-bottom-button button-res">
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            کتاب های من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </div>
                      <Link
                        to={"/activities"}
                        className="Profile-bottom-right-inside-center-border-button2"
                      >
                        <button
                          style={{
                            backgroundColor: "#D8EDFE",
                          }}
                          className="Profile-center-left-inside-right-bottom-button button-res"
                        >
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            کنش‌ها و نظرات من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="Profile-bottom-right-inside-bottom">
                    <div className="Profile-bottom-right-inside-center-display">
                      <Link
                        to={"/saved"}
                        className="Profile-bottom-left-inside-center-border-button1"
                      >
                        <button className="Profile-center-left-inside-right-bottom-button button-res">
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            ذخیره های من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </Link>
                      <Link
                        to={"/offer-codes"}
                        className="Profile-bottom-left-inside-center-border-button2"
                      >
                        <button className="Profile-center-left-inside-right-bottom-button button-res">
                          <p className="Profile-center-left-inside-right-bottom-button-text">
                            کدهای تخفیف من
                          </p>
                          <img
                            className="Profile-center-left-inside-right-bottom-button-image"
                            src="imgs/Profile/Felesh.svg"
                          />
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Profile-center-right">
              <div className="Profile-center-left-inside">
                <div className="Profile-center-left-inside-right">
                  <div className="Profile-center-left-inside-right-top">
                    <div className="Profile-center-left-inside-right-top-res">
                      <div className="Profile-center-left-inside-right-top-wallet">
                        <div className="Profile-center-left-inside-right-top-wallet-image-res">
                          <img
                            className="Profile-center-left-inside-right-top-wallet-image-res-img"
                            src="imgs/Profile/wallet.svg"
                          />
                        </div>
                        <p className="Profile-center-left-inside-right-top-wallet-text">
                          موجودی کیف پول شما
                        </p>
                        <img
                          className="Profile-center-left-inside-right-top-wallet-image"
                          src="imgs/Profile/wallet.svg"
                        />
                      </div>
                      <p className="Profile-center-left-inside-right-top-Money">
                        <span className="Profile-Money number-font">
                          {user.balance}
                        </span>
                        تومان
                      </p>
                    </div>
                  </div>
                  <div></div>
                  <div
                    className="Profile-center-left-inside-right-bottom dis"
                    onClick={() => setTransferModal(true)}
                  >
                    <button className="Profile-center-left-inside-right-bottom-button">
                      <p className="Profile-center-left-inside-right-bottom-button-text">
                        انتقال موجودی
                      </p>
                      <img
                        className="Profile-center-left-inside-right-bottom-button-image"
                        src="imgs/Profile/Felesh.svg"
                      />
                    </button>
                  </div>
                </div>
                <div className="Profile-center-left-inside-left">
                  <div
                    className="Profile-center-left-inside-left-bottom1 desktop-hidden"
                    onClick={() => setTransferModal(true)}
                  >
                    <button className="Profile-center-left-inside-right-bottom-button">
                      <p className="Profile-center-left-inside-right-bottom-button-text">
                        انتقال موجودی
                      </p>
                      <img
                        className="Profile-center-left-inside-right-bottom-button-image"
                        src="imgs/Profile/Felesh.svg"
                      />
                    </button>
                  </div>
                  <div
                    className="Profile-center-left-inside-left-bottom1"
                    onClick={() => setRechargewalletModal(true)}
                  >
                    <button className="Profile-center-left-inside-right-bottom-button wallet-box-profile">
                      <p className="Profile-center-left-inside-right-bottom-button-text">
                        شارژ کیف پول
                      </p>
                      <img
                        className="Profile-center-left-inside-right-bottom-button-image"
                        src="imgs/Profile/Felesh.svg"
                      />
                    </button>
                  </div>
                  <div
                    className="Profile-center-left-inside-left-bottom2"
                    onClick={() => setHistoryModal(true)}
                  >
                    <button className="Profile-center-left-inside-right-bottom-button wallet-box-profile">
                      <p className="Profile-center-left-inside-right-bottom-button-text">
                        تراکنش‌ ها
                      </p>
                      <img
                        className="Profile-center-left-inside-right-bottom-button-image"
                        src="imgs/Profile/Felesh.svg"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="Profile-bottom">
            <div className="Profile-bottom-right-border">
              <Link
                to={"/hisstori/club/invite-friend"}
                state={{ from: "profile" }}
                className="Profile-bottom-left-inside-top"
                id="order1"
              >
                <div className="Profile-bottom-left-inside-top-display">
                  <div className="Profile-bottom-left-inside-top-image-display">
                    <img
                      className="Profile-bottom-left-inside-top-image"
                      src="imgs/Profile/Adduser.svg"
                    />
                  </div>

                  <p className="Profile-bottom-left-inside-top-text">
                    دعوت از دوستان
                  </p>
                </div>
              </Link>
              <div className="Profile-bottom-left-inside-center" id="order2">
                <Link
                  to="/hisstori/blog/faq"
                  state={{ from: "profile" }}
                  className="Profile-bottom-left-inside-center-right"
                >
                  <div className="Profile-bottom-left-inside-top-display">
                    <div className="Profile-bottom-left-inside-top-image-display">
                      <img
                        className="Profile-bottom-left-inside-top-image"
                        src="imgs/Profile/Questionicon.svg"
                      />
                    </div>
                    <p className="Profile-bottom-left-inside-top-text">
                      سوال های پرتکرار
                    </p>
                  </div>
                </Link>
                <div
                  to="/hisstori/blog/keta-blog"
                  state={{ from: "profile" }}
                  className="Profile-bottom-left-inside-center-left"
                  onClick={() =>
                    navigator("/hisstori/blog/keta-blog", {
                      state: {
                        prevPath: `/profile`,
                      },
                    })
                  }
                >
                  <div className="Profile-bottom-left-inside-top-display">
                    <div className="Profile-bottom-left-inside-top-image-display">
                      <img
                        className="Profile-bottom-left-inside-top-image"
                        src="imgs/Profile/Booklog.svg"
                      />
                    </div>
                    <p className="Profile-bottom-left-inside-top-text">
                      کتابلاگ
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="Profile-bottom-left-border">
              <div className="Profile-bottom-left">
                <div className="Profile-bottom-left-inside">
                  <div
                    className="Profile-bottom-left-inside-bottom2"
                    id="order3"
                  >
                    <Link
                      to="/hisstori/blog/guide"
                      state={{ from: "profile" }}
                      className="Profile-bottom-left-inside-center-right"
                    >
                      <div className="Profile-bottom-left-inside-top-display">
                        <div className="Profile-bottom-left-inside-top-image-display">
                          <img
                            className="Profile-bottom-left-inside-top-image"
                            src="imgs/Profile/Guide.svg"
                          />
                        </div>
                        <p className="Profile-bottom-left-inside-top-text">
                          راهنما
                        </p>
                      </div>
                    </Link>
                    <Link
                      to="/hisstori/blog/alerts"
                      state={{ from: "profile" }}
                      className="Profile-bottom-left-inside-center-left"
                    >
                      <div className="Profile-bottom-left-inside-top-display">
                        <div className="Profile-bottom-left-inside-top-image-display">
                          <img
                            className="Profile-bottom-left-inside-top-image"
                            src="imgs/Profile/Notifications.svg"
                          />
                        </div>
                        <p className="Profile-bottom-left-inside-top-text">
                          اطلاعیه ها
                        </p>
                      </div>
                    </Link>
                  </div>
                  <Link
                    to={"/support"}
                    className="Profile-bottom-left-inside-top-bottom"
                    id="order4"
                  >
                    <div className="Profile-bottom-left-inside-top-display">
                      <div className="Profile-bottom-left-inside-top-image-display">
                        <img
                          className="Profile-bottom-left-inside-top-image Poshtibani"
                          src="imgs/Profile/Poshtibani.svg"
                        />
                      </div>

                      <p className="Profile-bottom-left-inside-top-text">
                        پشتیبانی
                      </p>
                    </div>
                  </Link>
                  {window.outerWidth < 785 ? (
                    <Link
                      to={"/printed-version"}
                      className="Profile-bottom-left-inside-top-bottom"
                      id="order4"
                      style={{ marginTop: "15px" }}
                    >
                      <div className="Profile-bottom-left-inside-top-display">
                        <div className="Profile-bottom-left-inside-top-image-display">
                          <img
                            className="Profile-bottom-left-inside-top-image Poshtibani"
                            src="imgs/Profile/chapVersion.svg"
                          />
                        </div>

                        <p className="Profile-bottom-left-inside-top-text">
                          دریافت سکه و امتیاز نسخه چاپی
                        </p>
                      </div>
                    </Link>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          {window.outerWidth > 785 ? (
            <Link
              to={"/printed-version"}
              className="Profile-bottom-left-inside-top-bottom"
              id="order4"
              style={{ marginTop: "15px" }}
            >
              <div className="Profile-bottom-left-inside-top-display">
                <div className="Profile-bottom-left-inside-top-image-display">
                  <img
                    className="Profile-bottom-left-inside-top-image Poshtibani"
                    src="imgs/Profile/chapVersion.svg"
                  />
                </div>

                <p className="Profile-bottom-left-inside-top-text">
                  دریافت سکه و امتیاز نسخه چاپی{" "}
                </p>
              </div>
            </Link>
          ) : null}
        </div>
      ) : (
        <Registerprofile />
      )}
    </Page>
  );
};
export default Profile;

const profileClubSwiperData = [
  {
    src: "/imgs/bashgah/bashgah-seke.svg",
    link: "/hisstori/club/my-coins",
  },
  {
    src: "/imgs/bashgah/bashgah-group.svg",
    link: "/hisstori/club/my-scores",
  },
  {
    src: "/imgs/bashgah/bashgah-medal.svg",
    link: "/hisstori/club/my-medals",
  },
  {
    src: "/imgs/bashgah/bashgah-user.svg",
    link: "/hisstori/club/invite-friend",
  },
  {
    src: "/imgs/bashgah/bashgah-heart.svg",
    link: "",
  },
  {
    src: "/imgs/bashgah/bashgah-tala.svg",
    link: "/hisstori/club/my-signs",
  },
];
